export class ProductType {
    id: any;
    name: string;

    static create(id, name) {
        const productType = new ProductType();
        productType.id = id;
        productType.name = name;
        return productType;
    }
}



// WEBPACK FOOTER //
// ./src/app/_models/producttype.ts